import { render, staticRenderFns } from "./trans_pay_m.vue?vue&type=template&id=3ee867e4"
import script from "./trans_pay_m.vue?vue&type=script&lang=js"
export * from "./trans_pay_m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports